<template>
<div class="pr-3 pl-3 inner-admin-container">
  <b-form v-on:submit.prevent="save">
    <b-form-group id="select-layer-admin-group" horizontal label-size="sm" label="Select layer group:" label-for="select-layer-admin">
      <b-form-select id="select-layer-admin" size="sm" type="text" v-model="q" :options="groups" placeholder="None">
      </b-form-select>
    </b-form-group>
    <div id="selected-layer-admin-container" v-if="selectedGroup">
      <b-row>
        <b-col>
          <div id='group-disable-layer-container'>
            <div id='group-initial-disable' v-if="state === 'DEFAULT'">
              <span>Disable layers in this group: </span>
              <b-button class="btn-xs" variant="primary" v-on:click.prevent="checkDisable">Disable</b-button>
            </div>
            <div id='group-initial-disable-check' v-if="state === 'CHECK'">
              <b-alert id='user-reminder' variant="warning" show>Are you sure you wish to disable all layers within this group?</b-alert>
              <b-button class="btn-xs" variant="primary" v-on:click.prevent="state = 'DEFAULT'">No</b-button>
              <b-button class="btn-xs" variant="primary" v-on:click.prevent="disable">Yes</b-button>
            </div>
          </div>
        </b-col>
      </b-row>
      <br>
      <b-row v-if="state !== 'CHECK'">
        <b-col>
          <h6>Group Settings</h6>
        </b-col>
      </b-row>
      <b-row v-if="state !== 'CHECK'">
        <b-col>
          <b-form-group label="Title" label-for="group-title">
            <b-form-input id="group-title" @change="commitKey('title')" v-model="selectedGroup['title']" placeholder="Enter title"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Expanded" label-for="group-expanded">
            <b-form-select id="group-expanded" @change="commitKey('expanded')" v-model="selectedGroup['expanded']" :options="['true', 'false']" placeholder="Toggle group expanded"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="state !== 'CHECK'">
        <b-col>
          <b-alert id='user-reminder' v-if="state === 'UPDATED'" variant="warning" show>User may need to refresh to see changes</b-alert>
          <b-button type="submit" class="btn-xs" variant="primary" v-on:submit.prevent="save">Save</b-button>
        </b-col>
      </b-row>
    </div>

  </b-form>
</div>
</template>
<script>
export default {
  data() {
    return {
      workpack: {},
      changedKeys: [],
      groups: [],
      q: null,
      selectedGroup: null,
      state: 'DEFAULT',
      disableIDs: []
    }
  },
  mounted() {
    let tree = this.$store.getters['map/layersTree']
    tree.forEach(l => {
      if (l.group && l.group.title) {
        this.groups.push({
          text: l.group.title,
          value: l.group.id
        })
        this.groups.sort(function(a, b){
          if(a.text < b.text) return -1;
          if(a.text > b.text) return 1;
          return 0;
      })
      }
    })
  },
  methods: {
    commitKey(key) {
      if (this.changedKeys.indexOf(key) === -1) {
        this.state = 'DEFAULT'
        this.changedKeys.push(key)
      }
    },
    checkDisable() {
      this.state = 'CHECK'
    },
    disable() {
      this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
        if (node.group_id && node.group_id === parseInt(this.selectedGroup.id)) {
          node.state = 'disabled'
          this.disableIDs.push(node.id)
        }
      })
      this.state = 'UPDATED'

      if (this.disableIDs.length) {
        this.$http.post('/api/admin-board/disable-layers/', {
          ids: this.disableIDs
        }).then(res => {
          this.state = "UPDATED"
          this.$notify({
            title: 'SUCCESS',
            text: 'Layers disabled',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not disable layers',
            type: 'error'
          })
        })
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'No layers in this group to disable',
          type: 'error'
        })
      }
    },
    save() {
      if (this.changedKeys.length > 0) {
        let p = {}
        this.changedKeys.forEach(k => p[k] = this.selectedGroup[k])
        this.$http.post('/api/admin-board/update-layer-group/', {
          id: this.selectedGroup['id'],
          data: p
        }).then(res => {
          this.state = "UPDATED"
          this.$notify({
            title: 'SUCCESS',
            text: 'Group settings updated',
            type: 'success'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not update group',
            type: 'error'
          })
        })
      } else {
        this.$notify({
          title: 'ERROR',
          text: 'No changes to save',
          type: 'error'
        })
      }
    }
  },
  watch: {
    q(g) {
      if (g) {
        this.state = 'DEFAULT'
        this.disableIDs = []
        this.changedKeys = []
        let tree = this.$store.getters['map/layersTree']
        tree.forEach(l => {
          if (l.group && l.group.id === g) {
            this.selectedGroup = l.group
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/LayerGroupSettings.vue